import { ChangeDetectorRef, Component, Inject, NgZone } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { trimEmailValidator } from 'src/app/core/utils/utilities';
import { IForgotPassword } from 'src/app/services/AuthService/auth.model';
import { AuthService } from 'src/app/services/AuthService/auth.service';
import { SharedService } from 'src/app/services/SharedService/shared.service';
import { SwalAlertService } from 'src/app/services/SwalAlertService/swalAlert.service';
import Swal from 'sweetalert2';
import { BRAND } from 'src/app/core/constants/brand';

@Component({
  selector: 'app-email-senha',
  templateUrl: './email-senha.component.html',
  styleUrl: './email-senha.component.scss'
})
export class EmailSenhaComponent {
  readonly brand = BRAND;
  form: FormGroup = this._inicializarFormulario();
  type: string = 'password';
  activeRoute: string = '';
  title: string = 'Enviar';
  isLoading: boolean = false;
  isEmpresa: boolean = false;
  model: any = {
    email: '',
    password: '',
    remember: false
  };

  constructor(
    private authService: AuthService,
    @Inject(Router) private router: Router,
    @Inject(ChangeDetectorRef) private cd: ChangeDetectorRef,
    private fb: FormBuilder,
    @Inject(NgZone) private ngZone: NgZone, // Inject NgZone
    private sharedService: SharedService,
    private swalAlert: SwalAlertService
  ) {}

  userType = this.authService.getCurrentUserType();

  ngOnInit() {
    this.isEmpresa =
      this.userType === 'PJ' ? true : this.sharedService.getIsEmpresa();
  }

  onSubmit() {
    const email = this.form.get('EMAIL')?.value;

    this.postarDados();
  }

  postarDados() {
    const payload = this.createPayload();
    this.isLoading = true;
    this.authService.forgotPassword(payload).subscribe(
      response => {
        this.swalAlert.showAlert(
          'Sucesso!',
          'Um e-mail com o link de redefinição foi enviado para o seu e-mail.',
          'success',
          true,
          false,
          { confirmButtonText: 'Ok', confirmButtonColor: 'green' },
          () => {
            this.isLoading = false;
            this.ngZone.run(() => {
              this.router.navigate(['login']);
            });
          }
        );
      },
      error => {
        this.isLoading = false;
      }
    );
  }

  createPayload(): IForgotPassword {
    const tipoAcessoEnum =
      this.userType === 'PJ' ? 1 : this.userType === 'PF' ? 2 : 3;

    return {
      AddressTo: this.form.controls['EMAIL'].value,
      TipoAcessoEnum: tipoAcessoEnum
    };
  }

  private _inicializarFormulario() {
    const form = this.fb.group({
      EMAIL: ['', [Validators.required, trimEmailValidator]]
    });
    return form;
  }

  public onBack() {
    this.router.navigate(['login']);
  }
}
